export default "__VITE_ASSET__B3RGj_l1__"